var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"map"}},[_c('g',{attrs:{"id":"panZoomRoot"}},[_c('g',{attrs:{"id":"mapPaths"}}),_c('g',{style:(_vm.vehicleStyle),attrs:{"id":"vehicleRoot"}},[_vm._l((_vm.vehicleData),function(vehicle){return [_c('Vehicle',{key:vehicle.properties.id,attrs:{"checkedValues":_vm.checkedValues,"vehicle":vehicle,"projection":_vm.projection}})]})],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02442c1b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapContainer.vue
// module id = null
// module chunks = 